import { type OperationVariables } from '@apollo/react-common';
import {
	type LazyQueryHookOptions,
	// eslint-disable-next-line graphql-relay-compat/no-import-apollo-functions -- `@confluence/apollo-relay-interop` package is the only one where such imports are allowed
	useLazyQuery,
} from '@apollo/react-hooks';
import { type GraphQLTaggedNode } from 'react-relay';
import { type DocumentNode } from 'graphql/language/ast';

import { toDocumentNode } from './toDocumentNode.ts';

export function useLazyQueryInterop<TData, TVariables = OperationVariables>(
	query: DocumentNode | GraphQLTaggedNode,
	options?: LazyQueryHookOptions<TData, TVariables>,
): ReturnType<typeof useLazyQuery<TData, TVariables>> {
	if (process.env.BUILD_VARIANT === 'relay') {
		throw new Error('[Relay migration] Method not implemented yet');
	} else {
		return useLazyQuery<TData, TVariables>(toDocumentNode(query), options);
	}
}
